import { render } from "./EndorserModal.vue?vue&type=template&id=3ed1fb5e"
import script from "./EndorserModal.vue?vue&type=script&lang=js"
export * from "./EndorserModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/dash/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__